/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Guide_With_Skipper_P1Inputs */

const es_marketplace_seo_spain_guide_with_skipper_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si prefieres relajarte a bordo, reserva un barco con patrón profesional o armador experimentado. El capitán se encarga de la navegación, rutas y seguridad mientras tú disfrutas del mar.`)
};

const gl_marketplace_seo_spain_guide_with_skipper_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se prefires relaxarte a bordo, reserva un barco con patrón profesional ou armador experimentado. O capitán encárgase da navegación, rutas e seguridade mentres ti gozas do mar.`)
};

const en_marketplace_seo_spain_guide_with_skipper_p1 = /** @type {(inputs: Marketplace_Seo_Spain_Guide_With_Skipper_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prefer to relax on board? Book a boat with a professional skipper or experienced owner. The captain handles navigation, routes and safety while you enjoy the sea.`)
};

/**
* | output |
* | --- |
* | "Prefer to relax on board? Book a boat with a professional skipper or experienced owner. The captain handles navigation, routes and safety while you enjoy the..." |
*
* @param {Marketplace_Seo_Spain_Guide_With_Skipper_P1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_guide_with_skipper_p1 = /** @type {((inputs?: Marketplace_Seo_Spain_Guide_With_Skipper_P1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Guide_With_Skipper_P1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_guide_with_skipper_p1(inputs)
	if (locale === "en") return en_marketplace_seo_spain_guide_with_skipper_p1(inputs)
	return es_marketplace_seo_spain_guide_with_skipper_p1(inputs)
});